export default __webpack_public_path__ + "static/media/Cornerstone.e28654e9.ttf";